export default {
  FETCH_PROFILE: 'FETCH_PROFILE',
  FETCH_PROFILE_SUCCESS: 'FETCH_PROFILE_SUCCESS',
  FETCH_PROFILE_FAILURE: 'FETCH_PROFILE_FAILURE',

  UPDATE_PROFILE: 'UPDATE_PROFILE',
  UPDATE_PROFILE_SUCCESS: 'UPDATE_PROFILE_SUCCESS',
  UPDATE_PROFILE_FAILURE: 'UPDATE_PROFILE_FAILURE',

  UPDATE_PROFILE_BASICS: 'UPDATE_PROFILE_BASICS',
  UPDATE_PROFILE_BASICS_SUCCESS: 'UPDATE_PROFILE_BASICS_SUCCESS',
  UPDATE_PROFILE_BASICS_FAILIRE: 'UPDATE_PROFILE_BASICS_FAILIRE',

  UPDATE_PROFILE_BIO: 'UPDATE_PROFILE_BIO',
  UPDATE_PROFILE_BIO_SUCCESS: 'UPDATE_PROFILE_BIO_SUCCESS',
  UPDATE_PROFILE_BIO_FAILURE: 'UPDATE_PROFILE_BIO_FAILURE',

  UPDATE_PROFILE_CONDITION: 'UPDATE_PROFILE_CONDITION',
  UPDATE_PROFILE_CONDITION_SUCCESS: 'UPDATE_PROFILE_CONDITION_SUCCESS',
  UPDATE_PROFILE_CONDITION_FAILURE: 'UPDATE_PROFILE_CONDITION_FAILURE',

  DELETE_PROFILE_CONDITION: 'DELETE_PROFILE_CONDITION',
  DELETE_PROFILE_CONDITION_SUCCESS: 'DELETE_PROFILE_CONDITION_SUCCESS',
  DELETE_PROFILE_CONDITION_FAILURE: 'DELETE_PROFILE_CONDITION_FAILURE',

  DELETE_PROFILE_INTEREST: 'DELETE_PROFILE_INTEREST',
  DELETE_PROFILE_INTEREST_SUCCESS: 'DELETE_PROFILE_INTEREST_SUCCESS',
  DELETE_PROFILE_INTEREST_FAILURE: 'DELETE_PROFILE_INTEREST_FAILURE',

  ADD_PROFILE_INTERESTS: 'ADD_PROFILE_INTERESTS',
  ADD_PROFILE_INTERESTS_SUCCESS: 'ADD_PROFILE_INTERESTS_SUCCESS',
  ADD_PROFILE_INTERESTS_FAILURE: 'ADD_PROFILE_INTERESTS_FAILURE',

  UPDATE_PROFILE_INTEREST_PRIVACY: 'UPDATE_PROFILE_INTEREST_PRIVACY',
  UPDATE_PROFILE_INTEREST_PRIVACY_SUCCESS: 'UPDATE_PROFILE_INTEREST_PRIVACY_SUCCESS',
  UPDATE_PROFILE_INTEREST_PRIVACY_FAILURE: 'UPDATE_PROFILE_INTEREST_PRIVACY_FAILURE',

  UPDATE_PROFILE_CONDITION_PRIVACY: 'UPDATE_PROFILE_CONDITION_PRIVACY',
  UPDATE_PROFILE_CONDITION_PRIVACY_SUCCESS: 'UPDATE_PROFILE_CONDITION_PRIVACY_SUCCESS',
  UPDATE_PROFILE_CONDITION_PRIVACY_FAILURE: 'UPDATE_PROFILE_CONDITION_PRIVACY_FAILURE',

  UPLOAD_PREVIEW_AVATAR_IMAGE: 'UPLOAD_PREVIEW_AVATAR_IMAGE',
  UPLOAD_PREVIEW_AVATAR_IMAGE_SUCCESS: 'UPLOAD_PREVIEW_AVATAR_IMAGE_SUCCESS',
  UPLOAD_PREVIEW_AVATAR_IMAGE_FAILURE: 'UPLOAD_PREVIEW_AVATAR_IMAGE_FAILURE',

  SAVE_AND_CROP_AVATAR_IMAGE: 'SAVE_AND_CROP_AVATAR_IMAGE',
  SAVE_AND_CROP_AVATAR_IMAGE_SUCCESS: 'SAVE_AND_CROP_AVATAR_IMAGE_SUCCESS',
  SAVE_AND_CROP_AVATAR_IMAGE_FAILURE: 'SAVE_AND_CROP_AVATAR_IMAGE_FAILURE',

  UPLOAD_PREVIEW_BANNER_IMAGE: 'UPLOAD_PREVIEW_BANNER_IMAGE',
  UPLOAD_PREVIEW_BANNER_IMAGE_SUCCESS: 'UPLOAD_PREVIEW_BANNER_IMAGE_SUCCESS',
  UPLOAD_PREVIEW_BANNER_IMAGE_FAILURE: 'UPLOAD_PREVIEW_BANNER_IMAGE_FAILURE',

  SAVE_AND_CROP_BANNER_IMAGE: 'SAVE_AND_CROP_BANNER_IMAGE',
  SAVE_AND_CROP_BANNER_IMAGE_SUCCESS: 'SAVE_AND_CROP_BANNER_IMAGE_SUCCESS',
  SAVE_AND_CROP_BANNER_IMAGE_FAILURE: 'SAVE_AND_CROP_BANNER_IMAGE_FAILURE',
};
